import { render } from "./Morgana.vue?vue&type=template&id=18111a47&scoped=true&ts=true"
import script from "./Morgana.vue?vue&type=script&lang=ts"
export * from "./Morgana.vue?vue&type=script&lang=ts"

import "./Morgana.vue?vue&type=style&index=0&id=18111a47&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18111a47"]])

export default __exports__